export default {

  data: () => ({
    calculationMatrix: [
      [0, 2, 4, 7],
      [2, 3, 6, 9],
      [5, 6, 7, 10]
    ],
    techHelpScore: 3,
    amenagementScore: 5,
    scores: []
  }),

  methods: {

    clearScores () {
      this.scores = []
    },

    computeAllScores (snapshotSection, length) {
      let datasource
      if (typeof snapshotSection !== 'undefined') {
        datasource = snapshotSection
      } else {
        datasource = this
      }

      let _length
      if (typeof length !== 'undefined') {
        _length = length
      } else {
        _length = this.section.children.length
      }

      for (let i = 0; i < _length; i++) {
        this.computeScore(i, datasource)
      }
    },

    computeScore (index, snapshotSection) {
      let datasource
      if (typeof snapshotSection !== 'undefined') {
        datasource = snapshotSection
      } else {
        datasource = this
      }
      let score
      if (typeof datasource.step1.value[index] === 'undefined' || datasource.step1.value[index] === null) {
        score = null
      } else {
        score = this.calculations(index, datasource)
      }
      this.scores[index] = score
    },

    calculations (index, snapshotSection) {
      let datasource
      if (typeof snapshotSection !== 'undefined') {
        datasource = snapshotSection
      } else {
        datasource = this
      }

      let result = datasource.step1.value[index].result
      switch (result) {
        case 'not':
          return 0
        case 'na':
          return ''
        case 'done':
          return this.calculateDone(index, datasource)
        default:
          return ''
      }
    },

    calculateDone (index, snapshotSection) {
      let datasource
      if (typeof snapshotSection !== 'undefined') {
        datasource = snapshotSection
      } else {
        datasource = this
      }

      let amenagementScore = 0
      let technicalHelpScore = 0
      let helpTypeIndex = 0
      let difficultyIndex = 0
      let helpType = datasource.step2.helpType.value[index]
      let difficulty = datasource.step2.difficultyLevel.value[index]

      if (typeof helpType === 'undefined' || typeof difficulty === 'undefined' || helpType == null || difficulty == null) {
        return 10 - (amenagementScore + technicalHelpScore) / 2
      }

      switch (helpType.result) {
        case 'no_help':
          helpTypeIndex = 0
          break
        case 'light':
          helpTypeIndex = 1
          break
        case 'heavy':
          helpTypeIndex = 2
          break
        case 'full':
          helpTypeIndex = 3
          break
        default:
          helpType = 0
      }
      switch (difficulty.result) {
        case 'low':
          difficultyIndex = 0
          break
        case 'medium':
          difficultyIndex = 1
          break
        case 'heavy':
          difficultyIndex = 2
          break
        default:
          difficultyIndex = 0
      }

      let finalScore = this.calculationMatrix[difficultyIndex][helpTypeIndex]

      if (datasource.step2.helpType.technicalHelp[index] && typeof datasource.step2.helpType.technicalHelp[index] !== 'undefined' && datasource.step2.helpType.technicalHelp[index] !== null) {
        finalScore += this.techHelpScore
      }
      if (datasource.step2.helpType.amenagement[index] && typeof datasource.step2.helpType.amenagement[index] !== 'undefined' && datasource.step2.helpType.amenagement[index] !== null) {
        finalScore += this.amenagementScore
      }

      return (20 - finalScore) / 2
    },

    average (data) {
      var value = 0
      var length = data.length
      for (let i = 0; i < data.length; i++) {
        if (data[i] === '' || data[i] === null) {
          length--
          continue
        }
        value += data[i]
      }
      if (length > 0) {
        return value / length
      } else {
        return 0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/utils/Calculations.js